import { Button } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseURL } from '../../../Config/axios'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { ProjectDetailsFn } from '../../../Services/Project/ProjectDetails'
import { toast } from 'react-toastify'
import { baseUrl } from '../../../Config/baseUrl'

const ProjectListDeatilesByCategory = () => {


    const navigate = useNavigate()

    const { id } = useParams()

    const [data, setData] = useState();


    console.log(data)



    const blogData = () => {
        axios
            .get(`${baseUrl}/blog/projectlist-api/`, {

                params: { project_id: id },
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => {


                console.log("responseeeeeeeeeeeee", res?.data?.data)
                setData(res?.data?.data);
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
            });
    };
    useEffect(() => {
        blogData();
    }, []);






    const DetailDataDelete = (p_id) => {




        const fd = new FormData()
        fd.append("projectlist_id", p_id)
        axios
            .delete(`${baseUrl}/blog/projectlist-api/`, {


                data: {

                    projectlist_id: p_id

                },

                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,

                },
            })
            .then((res) => {
                console.log("responseeeeeeeeeeeee", res?.data?.data);
                setData(res?.data?.data);
                blogData();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
            });
    };

    const deleteDetails = (p_id) => {

        console.log("djkdgdghdghdghgh")

        DetailDataDelete(p_id);



    }











    return (

        <>
            <NavLink to={`/addspesficprojectdetails/${id}/add`}>
                <div className="text-xl font-bold !text-gray-600 p-3 pr-[10%]">
                    <Button variant="outlined">Add</Button>
                </div>
            </NavLink>
            <table className="min-w-full border border-collapse border-gray-300 table-auto">



                <thead>
                    <tr className="border-b">
                        <th className="px-4 py-2 text-lg font-semibold text-left text-black">Title</th>
                        <th className="px-4 py-2 text-lg font-semibold text-left text-black">Discription</th>
                        <th className="px-4 py-2 text-lg font-semibold text-left text-black">Images</th>
                        <th className="px-4 py-2 text-lg font-semibold text-left text-black">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item) => (
                        <tr key={item.id} className="border-b">
                            <td className="px-4 py-2 overflow-hidden text-lg text-black text-ellipsis">
                                {item.title}
                            </td>
                            <td
                                className="px-4 py-2 overflow-hidden text-lg text-black text-ellipsis"
                                style={{
                                    whiteSpace: 'nowrap',  // Prevents text from wrapping to the next line
                                    overflow: 'hidden',    // Ensures overflow is hidden
                                    textOverflow: 'ellipsis',  // Adds the ellipsis when text overflows
                                    maxWidth: '200px'      // You can adjust this to whatever width you prefer
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: item?.description
                                }}
                            >
                            </td>




                            <td className="px-4 py-2 overflow-hidden text-lg text-black text-ellipsis"
                            >

                                <img src={item?.image} alt='img' className='h-20 w-fit' />
                            </td>
                            <td className="px-4 py-2 text-lg text-black">
                                <div className="flex justify-start space-x-4">
                                    <Button
                                        onClick={() => navigate(`/addspesficprojectdetails/${id}/update`, { state: item.id })}
                                        variant="outlined"
                                    >
                                        Update
                                    </Button>
                                    <Button onClick={() => deleteDetails(item.id)} variant="outlined">
                                        Delete
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </>
    )
}

export default ProjectListDeatilesByCategory